/** The demo script, in ms into the 20-second loop (see stage.js).
 *  Left: the agent adds two properties. Right: a tenant applies to Mare Street, and at `arrive` it lands on the agent's dashboard. */

export const AGENCY = "Hackney Lettings";

export const PROPERTY = { address: "Flat 2, 14 Mare Street, London E8", rent: 1950, moveIn: "1 December 2026" };

/** Each "Add property" run: cursor moves to the button, clicks, types into the dialog, saves. */
export const ADDS = [
  { cursor: 800, press: 1600, open: 1750, address: 2050, rent: 3500, date: 3850, toSave: 4300, save: 4950, added: 5100,
    property: { id: "elgin", address: "Flat 4, 27 Elgin Avenue, London W9", rent: 2350, moveIn: "15/01/2027", photo: { x: "62%", y: "56%" } } },
  { cursor: 8300, press: 9100, open: 9250, address: 9550, rent: 11000, date: 11350, toSave: 11800, save: 12450, added: 12600,
    property: { id: "ashchurch", address: "8 Ashchurch Grove, London W12", rent: 2100, moveIn: "01/02/2027", photo: { x: "100%", y: "52%" } } },
];

/** The tenant's phone, step by step. */
export const TENANT = {
  start: 1100,
  id: 1500, idUpload: 2300, idChecked: 3900, idNext: 4700,
  pay: 5100, payPick: 6000,
  payslips: 6700, slipUpload: 7400, slipChecked: [8700, 9050, 9400], slipNext: 10150,
  bank: 10500, bankConnect: 11200, bankChecking: 11650, bankChecked: 12600, bankNext: 13250,
  review: 13600, send: 14800,
  done: 15200,
};

/** The application reaches the agent's dashboard. */
export const ARRIVE = 16300;

/** With reduced motion, both demos hold this frame: every property added, the application sent and arrived. */
export const STILL = 17200;

export const PRESS_MS = 220;
